(function () {
    'use strict';

    angular
        .module('adm')
        .controller('AdmDepartmentCreateController', AdmDepartmentCreateController);

    AdmDepartmentCreateController.$inject = ['AdmService','$state'];

    function AdmDepartmentCreateController(AdmService, $state) {
        var vm              = this;
        vm.activate         = activate;
        vm.storeDepartment  = storeDepartment;
        vm.create           = [];

        function storeDepartment()
        {
            vm.query = {};
            vm.query['name'] = vm.create.name;
            vm.query['description'] = vm.create.description;
            AdmService.save(vm.query).then(function(response){
                $state.go('root.adm.department.list');
            });
        }
        function activate() {
        }
        vm.activate();
    }

})();